import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { verifyauthCheck, getDashboardStats, updateProfile, updateProfileInfo } from "../handlers/adminApi";
import _ from 'lodash';
import image50 from '../StyledComponents/img/user.png';
import imag from '../StyledComponents/img/logo (11).png';
import imag2 from '../StyledComponents/img/aq1.png'; 
import { jwtDecode } from 'jwt-decode'; 
import user from '../StyledComponents/img/user.png';

function Profile() {
    const [userData, setUserData] = useState(null);
    const [profileImage, setProfileImage] = useState(imag2); 
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null); // New state to handle errors
    const hasRun = useRef(false);
    const location = useLocation();
    const navigate = useNavigate();

    const authCheck = async () => {
        try {
            const resp = await verifyauthCheck();
            if (resp && resp.status === true) {
                setUserData(resp.userData);
            }
        } catch (error) {
            console.error('Authentication check failed:', error);
        }
    };

    const getDashboardStatistics = async () => {
        try {
            const resp = await getDashboardStats();
        } catch (error) {
            console.error('Error fetching dashboard stats:', error);
        }
    };

    useEffect(() => {
        const savedUserData = location.state?.userData;
        if (savedUserData) {
            setUserData(savedUserData); 
        }
    }, [location.state]);

    const handleFileInputChange = async (event) => {
        setLoading(true);
        const file = event.target.files[0];
        const data = {
            id: userData.id,
            file
        };
        console.log("Sending data:", data);
        const response = await updateProfile(data);
        console.log("Response from file upload:", response);
        if (_.get(response, 'status', true)) {
            setUserData(response.data); 
            localStorage.setItem('token', response.token); 
            navigate(location.pathname, { state: { ...location.state, userData: response.data } });
        }
        setLoading(false);
    };

    const handleInputChange = async (event) => {
        const { name, value } = event.target;
        // Update the specific field of userData when input value changes
        setUserData((prevData) => ({
            ...prevData,
            [name]: value,  // Dynamically update the property (either name or email)
        }));
    }

    const handleEditProfile = async (event) => {
        event.preventDefault(); // Prevent form from submitting and refreshing the page
        
        setLoading(true); // Show loading state
        setError(null); // Clear previous errors if any

        const data = {
            id: userData.id,
            name: userData.name,
            email: userData.email
        };

        try {
            const response = await updateProfileInfo(data);
            console.log("Response from profile update:", response);

            if (_.get(response, 'status', true)) {
                setUserData(response.data); // Update state with new data
                localStorage.setItem('token', response.token); // Save token if needed
                navigate(location.pathname, { state: { ...location.state, userData: response.data } }); // Optionally navigate to avoid refresh
            } else {
                setError("Profile update failed, please try again."); // Show error message if update fails
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            setError("An error occurred while updating the profile.");
        }
        setLoading(false); // Hide loading state once done
    };

    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            authCheck();
            getDashboardStatistics();
        }
    }, []);

    return (
        <div className="profile-main">
            <div className="log-in-inner">
                <div className="top">
                    <div className="top-inner">
                        <div className="logo">
                            <Link to="/whooska/admin/dashboard">
                                <img src={imag} alt="Logo" className="logo-w"/>
                            </Link>
                        </div>
                        <div className="user">
                            <div className="imgs" style={{
                                display: 'inline-block',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                padding: '5px'
                            }}>
                                <img
                                    src={`${process.env.REACT_APP_API_HOSTNAME}${userData?.profileImage}`}
                                    alt="User Profile"
                                    className="profile-picture"
                                    onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = image50; // Fallback image
                                    }}
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <div className="text-content">
                                <h5 className="title">{userData ? userData.name : 'John Deo'}</h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form">
                    <form onSubmit={handleEditProfile}>
                        <h2>Profile</h2>

                        <div className="logo">
                            <div className="imgs" style={{
                                display: 'inline-block',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                padding: '5px'
                            }}>
                                <img
                                    src={`${process.env.REACT_APP_API_HOSTNAME}${userData?.profileImage}`}
                                    alt="User Profile"
                                    className="profile-picture"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = image50;
                                    }}
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }}
                                />
                                <label htmlFor="file-upload" className="edit-icon">
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                </label>
                            </div>
                            <input
                                type="file"
                                id="file-upload"
                                style={{ display: 'none' }}
                                onChange={handleFileInputChange}
                            />
                        </div>

                        <div className="admin">
                            <a>Admin</a>
                        </div>
                        {loading ? (
                            <p>Loading...</p> // Display loading message
                        ) : error ? (
                            <p style={{ color: 'red' }}>{error}</p> // Display error message
                        ) : (
                            <div>
                                <div className="form-group fullname">
                                    <label htmlFor="fullname">Name</label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            id="fullname"
                                            name="name" // Add name attribute
                                            value={userData?.name || ''} 
                                            onChange={handleInputChange} // Bind onChange for dynamic state update
                                        />
                                        <FontAwesomeIcon icon={faPencilAlt} className="input-icon" />
                                    </div>
                                </div>

                                <div className="form-group fullname">
                                    <label htmlFor="email">Email</label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            id="email"
                                            name="email" // Add name attribute
                                            value={userData?.email || ''}
                                            onChange={handleInputChange} // Bind onChange for dynamic state update
                                        />
                                        <FontAwesomeIcon icon={faPencilAlt} className="input-icon" />
                                    </div>
                                </div>

                                <div className="btn">
                                    <button
                                        type="submit"
                                        style={{
                                            width: '500px',
                                            backgroundColor: '#F7812A',
                                            borderRadius: '50px',
                                            height: '50px',
                                            border: 'none',
                                            color: 'white',
                                            fontSize: '19px',
                                        }}
                                        disabled={loading} // Disable button during loading
                                    >
                                        Update Profile
                                    </button>
                                </div>
                            </div>
                        )}
                    </form>
                </div>

                <div className="bottom">
                    <div className="bottom-inner">
                        <div className="text-content">
                            <div className="copy">copyright @ WhooshkaTips</div>
                            <div className="text">
                                This page is for 18+ only. Gamble Responsibly. Visit
                                <span> www.gamblinghelponline.org.vic.au</span> or call <br />
                                Gambling Help on <span>1800 858 858</span>
                                The chances are you are about to lose
                            </div>
                            <div className="policy">
                                Privacy Policy | Terms & Conditions
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
